module.exports = __webpack_public_path__ + "img/pbs-106-7.4e27877c.png";